import { render, staticRenderFns } from "./family_list.vue?vue&type=template&id=624ed2ac&scoped=true"
import script from "./family_list.vue?vue&type=script&lang=js"
export * from "./family_list.vue?vue&type=script&lang=js"
import style0 from "./family_list.vue?vue&type=style&index=0&id=624ed2ac&prod&scoped=true&lang=less"
import style1 from "./family_list.vue?vue&type=style&index=1&id=624ed2ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ed2ac",
  null
  
)

export default component.exports